import Modal from '@Components/Shared/Modals/Modal';

const UnsupportedBrowserModal = (props) => {
    return (
        <Modal containerClassName='unsupported-browser-modal' setDisplayNone>
            <Modal.Body>
                <p id='dialog-label' >Your current browser cannot run our content, please make sure your browser is fully updated or try one of the browsers below.</p>
                <p id='description-label' className='hidden'>Your browser is not supported</p>
                <div className='browser-list'>
                    <div>
                        <a href='https://www.microsoft.com/en-us/edge'>
                            <i className='fab fa-edge fa-7x' />
                            <p>Microsoft Edge</p>
                        </a>
                    </div>
                    <div>
                        <a href='https://www.google.com/chrome'>
                            <i className='fab fa-chrome fa-7x' />
                            <p>Google Chrome</p>
                        </a>
                    </div>
                    <div>
                        <a href='https://www.mozilla.org/en-US/firefox/browsers/'>
                            <i className='fab fa-firefox fa-7x' />
                            <p>Mozilla Firefox</p>
                        </a>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default UnsupportedBrowserModal;